import boxpostLogo from '../assets/img/logos/boxpost.png';
import citypostLogo from '../assets/img/logos/citypost.png';
import ecologisticLogo from '../assets/img/logos/ecologistic.png';
import jonexpressLogo from '../assets/img/logos/jonexpress.png';
import koderLogo from '../assets/img/logos/koder.svg';
import logistarLogo from '../assets/img/logos/logistar.png';
import myboxLogo from '../assets/img/logos/MyBox.png';
import postexpressLogo from '../assets/img/logos/postexpress.png';
import upmpostLogo from '../assets/img/logos/upmpost.png';

const logos = {
  koder: koderLogo,
  ecologistic: ecologisticLogo,
  ecologistictest: ecologisticLogo,
  citypost: citypostLogo,
  postexpress: postexpressLogo,
  logistar: logistarLogo,
  mybox: myboxLogo,
  boxpost: boxpostLogo,
  jonexpress: jonexpressLogo,
  upmpost: upmpostLogo,
};

export default logos;
